// @ts-nocheck
document.addEventListener("alpine:init", () => {
  Alpine.data(
    "ctrCartProgress",
    ({
      initialAmount,
      currencyDivider,
      giftProductBlockTitle,
      milestones,
      autoFetch,
      loading,
      containerSelector,
      insertPosition,
      pricePattern,
    }) => ({
      amount: initialAmount ?? 0,
      currencyDivider: currencyDivider ?? 100,
      isGiftProductVisible: false,
      giftProductBlockTitle:
        giftProductBlockTitle ?? "Choose your free tea sample:",
      giftThreshold: 0,
      giftProduct: null,
      milestones: milestones.sort((a, b) => a.amount - b.amount),
      autoFetch: autoFetch ?? true,
      loading: loading ?? false,
      containerSelector: containerSelector ?? ".cart-items__wrapper",
      insertPosition: insertPosition ?? "prepend",
      pricePattern: pricePattern ?? "[amount]",

      get amountMajor() {
        return this.amount / this.currencyDivider;
      },

      updateGiftProductVisibility() {
        this.isGiftProductVisible = !!this.giftProduct;
      },

      progress() {
        const pts = this.milestones;
        if (!pts.length) return 0;

        if (this.amount <= pts[0].amount) return pts[0].percent;
        if (this.amount >= pts[pts.length - 1].amount)
          return pts[pts.length - 1].percent;

        for (let i = 0; i < pts.length - 1; i++) {
          const a = pts[i],
            b = pts[i + 1];
          if (this.amount >= a.amount && this.amount <= b.amount) {
            const t = (this.amount - a.amount) / (b.amount - a.amount);
            return a.percent + t * (b.percent - a.percent);
          }
        }
        return 0;
      },

      addGiftProduct(productId) {
        console.log("addGiftProduct", productId);
      },

      handleGiftProduct(isGiftProductAvailable, isGiftProductInCart) {
        if (!this.isGiftProductVisible) return;
        this.$dispatch("cart-progress:display-gift-product", {
          giftProduct: this.giftProduct,
          title: this.giftProductBlockTitle,
          isGiftProductAvailable: isGiftProductAvailable,
          isGiftProductInCart: isGiftProductInCart,
        });
      },

      formatPrice(price) {
        if (!price) return this.pricePattern.replace("[amount]", "0.00");

        return this.pricePattern.replace(
          "[amount]",
          (price / this.currencyDivider).toFixed(2)
        );
      },

      unlockedRewards() {
        return this.milestones.filter(
          (m) => m.reward && this.amount >= m.amount
        );
      },

      nextReward() {
        return (
          this.milestones.find((m) => m.reward && this.amount < m.amount) ||
          null
        );
      },

      formatRewardMessage(message) {
        if (!message) return "";

        const amount = this.formatPrice(
          this.nextReward().amount - this.amount > 0
            ? this.nextReward().amount - this.amount
            : 0
        );
        return message.replace("[amount]", `${amount}`);
      },

      async fetchCart() {
        this.loading = true;
        try {
          const res = await fetch(Theme.routes.cart_url, {
            headers: { Accept: "application/json" },
          });
          if (res.ok) {
            const cart = await res.json();
            this.amount = cart.total_price;

            if (
              this.isGiftProductInCart(cart) &&
              !this.isGiftProductAvailable()
            ) {
              document
                .querySelector(`[data-product-id="${this.giftProduct.id}"]`)
                .click();
            }

            this.giftProduct = this.milestones.find(
              (m) => m.product_gift
            )?.product_gift;
            this.updateGiftProductVisibility();

            this.handleGiftProduct(
              this.isGiftProductAvailable(),
              this.isGiftProductInCart(cart)
            );
          }
        } catch (e) {
          console.warn("ctr-cart-progress: fetchCart error", e);
        } finally {
          this.loading = false;
        }
      },

      isGiftProductAvailable() {
        const milestoneWithProduct = this.milestones.find(
          (m) => m.product_gift
        );
        if (!milestoneWithProduct) return false;

        return milestoneWithProduct.amount <= this.amount;
      },

      isGiftProductInCart(cart) {
        if (!this.giftProduct || !cart.items) return false;
        const giftProductId = this.giftProduct.id;

        return Boolean(
          cart.items.find((item) => item.product_id === giftProductId)
        );
      },

      init() {
        if (this.autoFetch) this.fetchCart();
        this.updateGiftProductVisibility();

        window.addEventListener("cart:update", () => this.fetchCart());
        window.addEventListener("cart:update", (e) => {
          const price = e?.detail?.cart?.total_price;
          if (typeof price === "number") this.amount = price;
          else this.fetchCart();
        });
      },
    })
  );
});
